import vars from '../helpers';

const showElement = (button, elem) => {
	const footer = $('.footer');

	const classNames = {
		activity: 'element--visible',
		inactivity: 'element--hidden',
	};
	if (vars.isMobile()) {
		button.on('click', (e) => {
			e.preventDefault();
			if (!elem.hasClass(classNames.activity)) {
				elem.addClass(classNames.activity);
				button.addClass(classNames.inactivity);
			}
		});

		$('.article__content, .footer__shares, .home__wrapper').on('click', () => {
			if (elem.hasClass(classNames.activity)) {
				elem.removeClass(classNames.activity);
				button.removeClass(classNames.inactivity);
			}
		});
	} else {
		console.debug('mob inited');

		button.on('mouseenter', (e) => {
			e.preventDefault();
			if (!elem.hasClass(classNames.activity)) {
				elem.addClass(classNames.activity);
				button.addClass(classNames.inactivity);
			} else {
				elem.removeClass(classNames.activity);
				button.removeClass(classNames.inactivity);
			}
		});

		footer.on('mouseleave', (e) => {
			if (elem.hasClass(classNames.activity)) {
				elem.removeClass(classNames.activity);
				button.removeClass(classNames.inactivity);
			}
		});
	}
};

function init() {
	const teamButton = $('.footer__team');
	const tooltip = $('.footer__team--tooltip');

	const sharesButton = $('.footer__shares--trigger');
	const shares = $('.footer__shares--buttons');

	showElement(teamButton, tooltip);
	showElement(sharesButton, shares);

	console.debug('footer inited');
}

export default {
	init,
};
